import BankAccountsFilter from './BankAccountsFilter';

export default BankAccountsFilter;
